import { PolicyConfirmModal } from '../policy-confirm-modal'
import type { CancellationPolicyResetModalProps } from './cancellation-policy-reset-modal.interface'
import classes from './cancellation-policy-reset-modal.module.scss'

export function CancellationPolicyResetModal({
  types,
  isLoading,
  onCancel,
  onConfirm,
}: CancellationPolicyResetModalProps) {
  const count = types.length
  return (
    <PolicyConfirmModal
      title="Apply the account policy to existing appointment types?"
      cancelLabel="Cancel"
      confirmLabel={`Reset ${count} ${count === 1 ? 'type' : 'types'}`}
      destructive
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      testId="cancellation-policy-reset-modal"
    >
      <p>These types will use the account policy. Their own settings will be removed.</p>
      <ul className={classes.types}>
        {types.map((type) => (
          <li key={type.id}>
            <strong>{type.name}</strong>
            <span className={classes.summary}>{type.summary}</span>
          </li>
        ))}
      </ul>
      <p>This change applies to all future appointments, including those booked under a previous policy.</p>
    </PolicyConfirmModal>
  )
}
